const tokenAlias = btoa('token');
const roleAlias = btoa('role');
const mutations = {
  setToken: (state: any, token: string) => {
    state.token = token;
    localStorage[tokenAlias] = token;
  },
  setRole: (state: any, id: string) => {
    state.role = id;
    localStorage[roleAlias] = id;
  },
  clearToken: (state: any) => {
    state.token = '';
    localStorage.removeItem(tokenAlias);
  },
  Logout: (state: any) => {
    //退出登录的操作,需要清楚的一些状态
    state.token = '';
    localStorage.removeItem(tokenAlias);
    state.user = null;
    state.role = "";
  },
  setConfig(state, systemConfig) {
    document.title = systemConfig.systemName || "观数台";
    state.systemConfig = systemConfig;
  },
  setAuth(state, val) {
    state.isAuth = val;
  },
  setUsage(state, val) {
    state.Usage = val;
  },
  ADD_CONFIG(state, data) {
    state.uiConfig = data;
  },
  setMessages(state, message) {
    state.messages = message;
  },
  setLang(state, lang) {
    state.language = lang;
  },
  setUser(state, obj) {
    state.user = obj;
  },
  setSocket(state, object) {
    state.messageSocket = object;
  },
  socketMessage(state, msg) {
    if (!msg.data) return;
    let msgData = [];

    if (msg.isHttp) {
      // http请求获取的数据
      msgData = msg.data;
    } else {
      // socket获取的数据
      const serializeData = JSON.parse(msg.data);
      const { data, socketType } = serializeData;
      state.braggerData = null;
      if (
        (socketType == 2 && data && data == 2) ||
        (socketType == 3 && data && data.state && data.state !== 1)
      ) {
        // 在线用户被迫下线 在线产品用户下线
        state.socketType = socketType;
      } else if (socketType == 4 && data) {
        // 评论弹幕;
        state.braggerData = data;
        state.socketType = socketType;
      } else {
        state.socketType = null;
      }
      if (socketType !== 1) return;
      msgData = data;
    }

    state.msgData = msgData;
  },
  setCount(state, count) {
    // 消息提示的条数，留待调试使用
    state.countSum = {
      newCommentCount: count.commentCount,
      newMessageCount: count.msgCount,
      atMsg: count.atMsg,
      disMe: count.disMe,
      annoMsg: count.annoMsg,
      loginMsg: count.loginMsg + count.editUserMsg,
      fansMsg: count.fansMsg,

    }
  },

  setUpperRouts(state, count) {
    state.upperRouts = {
      label: count.label,
      parentId: count.parentId,
      typeFs: count.typeFs
    }

  },
  setloadding(state, count) {
    state.loadding = count
  },
  setMsgdata(state, count) {
    state.msgdata1 = count
  },

  setRandomNum(state, count) {
    state.randomNum = count
  },
  setAsyncRoutes(state, routes) {
    state.asyncRoutes = routes;
  },
  setIsPortal(state, status) {
    state.isPortal = status;
  },
  setIsEDC(state, status) {
    state.isEDC = status;
  },
  setIsBI(state, status) {
    state.isBI = status;
  }
};
export default mutations;
